import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  all: [],
  options: [],
  columns: [
    {
      label: 'Name', field: 'name'
    },
    {
      label: 'Description', field: 'desc'
    },
    {
      label: 'Action', field: 'action'
    }
  ],
  pages: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/help/category-subs/status/AC'}
    useIPA.get(param).then(response => {
      const help = {
        rows : response.data.data,
        pages : [10, 25, 50, 150]
      }
      commit('setData', {...help})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/help/category/sub/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        name: formData.text_1,
        desc: formData.text_2
			}
      const param = { rawData: rawData, url: 'dashboard/master/help/category/sub', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/help/category/sub', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, help) {
    state.all = help.rows
    state.pages = help.pages
    state.options = []
    for (let i = 0; i < help.rows.length; i++) {
      const option = []
      for (const key in help.rows[i]) {
        if (key === 'id') { 
          option['value'] = help.rows[i][key] 
        } else if (key === 'name') { 
          option['title'] = help.rows[i][key] 
        } else if (key === 'id') { 
          option['oid'] = help.rows[i][key] 
        } 
      }
      state.options.push(Object.assign({}, option))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
